// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"GithubLink_bannerWrapper__PG7yQ","textSide":"GithubLink_textSide__TdSjd"};